import { FileIcon, defaultStyles } from 'react-file-icon';

const FileExtIcon = ({extension, type, width = '22px'}) => {
    return (
        <div style={{width}}>
            <FileIcon extension={extension} type={type} labelUppercase {...defaultStyles[extension]} />
        </div>
    );
}

export default FileExtIcon;